import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=47577c49&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47577c49",
  null
  
)

export default component.exports